import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND = (window.BACKEND_URL || process.env.REACT_APP_BACKEND_URL || '');

/**
 * Los documentos (DNI, contratos...) y las fotos de jugadores subidos como archivo ya no se pueden abrir con un
 * enlace público: el backend exige la sesión. Como <img src> y window.open no envían el token, estos archivos se
 * piden con axios (que sí lo envía) y se muestran a partir de una URL temporal en memoria (blob:).
 */
export const isProtectedPath = (u) => typeof u === 'string' && /\/api\/uploads\/(documents|players)\//.test(u);

export const absoluteUrl = (u) => (!u ? u : /^(https?:|data:|blob:)/.test(u) ? u : `${BACKEND}${u}`);

export async function fetchProtectedBlob(u) {
  const res = await axios.get(absoluteUrl(u), { responseType: 'blob' });
  return res.data;
}

/** Abre un archivo (protegido o no) en una pestaña nueva. */
export async function openProtectedFile(u) {
  if (!u) return;
  if (!isProtectedPath(u)) {
    window.open(absoluteUrl(u), '_blank', 'noopener');
    return;
  }
  // La ventana se abre antes de pedir el archivo para que el navegador no la bloquee
  const w = window.open('about:blank', '_blank');
  try {
    const blob = await fetchProtectedBlob(u);
    const url = window.URL.createObjectURL(blob);
    if (w) { w.location.href = url; } else { window.location.href = url; }
  } catch (e) {
    if (w) w.close();
    const status = e?.response?.status;
    toast.error(status === 404 || status === 403 ? 'No tenés permiso para abrir este archivo' : 'No se pudo abrir el archivo');
  }
}

/** Devuelve una URL lista para usar en <img src> (o null mientras carga / si falló). */
export function useProtectedSrc(u) {
  const [state, setState] = useState({ src: null, type: null, failed: false });
  useEffect(() => {
    let revoked = false;
    let objectUrl = null;
    if (!u) { setState({ src: null, type: null, failed: false }); return undefined; }
    if (!isProtectedPath(u)) { setState({ src: absoluteUrl(u), type: 'direct', failed: false }); return undefined; }
    setState({ src: null, type: null, failed: false });
    fetchProtectedBlob(u)
      .then((blob) => {
        if (revoked) return;
        objectUrl = window.URL.createObjectURL(blob);
        setState({ src: objectUrl, type: blob.type, failed: false });
      })
      .catch(() => { if (!revoked) setState({ src: null, type: null, failed: true }); });
    return () => {
      revoked = true;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [u]);
  return state;
}
